import { useEffect } from 'react';
import LogRocket from 'logrocket';
import Header from '../../components/Header';
import useUser from '../../hooks/useUser';

export default function Layout({ children }: { children: any }) {
  const user = useUser();

  useEffect(() => {
    if (user) {
      LogRocket.identify(user.person_id.toString());
    }
  }, [user?.person_id]); // Only re-run when the user ID changes

  return (
    <div className="dsm">
      <Header />
      {children}
    </div>
  );
}
